import React from "react";
import { connect } from "react-redux";
const ShowRating = props => {
  console.log(props);
  return (
    <div className="betterview">
      <h1>Your Rating:{props.rating}/5</h1>
      <h3>Total Rating:{props.totalrating}</h3>
      <h3>Avg Rating:{(props.totalrating / props.numberofratings).toPrecision(3)}</h3>
    </div>
  );
};
export default connect(store => {
  return store;
})(ShowRating);
